export const SET_EMAIL = 'SET_EMAIL';
export const SUBMIT_EMAIL = 'SUBMIT_EMAIL';
export const SET_PASSWORD = 'SET_PASSWORD';
export const SUBMIT_PASSWORD = 'SUBMIT_PASSWORD';
export const SET_VERIFICATION_CODE = 'SET_VERIFICATION_CODE';
export const SUBMIT_VERIFICATION_CODE = 'SUBMIT_VERIFICATION_CODE';
export const SET_ERROR = 'SET_ERROR';
export const CLEAR_FORGOT_PASSWORD_INFO = 'CLEAR_FORGOT_PASSWORD_INFO';